import ThemeProvider from '@voltmoney/theme';
import React, { memo, useEffect, useState, } from 'react';
import { Animated, Dimensions, PanResponder, SafeAreaView, ScrollView, } from 'react-native';
import { View, StyleSheet } from 'react-native';
import { BorderRadiusTokens, ColorTokens, } from '@voltmoney/schema';
/**
 * Raw Component with Derived props + Theme
 */
const theme = ThemeProvider.getTheme();
const colorMapping = theme.colors;
const borderRadiusMapping = theme.borderRadius;
const BottomSheetBase = ({ children, widgetItems, renderItem, padding = {
    top: 0,
    bottom: 0,
    left: 16,
    right: 16,
    vertical: 0,
    horizontal: 16,
}, initialOffset = 0.25, finalOffSet = 0.8, headerChildren, widgetHeaderItems, }) => {
    const scrollValue = 5;
    const [scrollOffSetY, setScrollOffSet] = useState(0);
    const [open, setOpen] = useState(false);
    const windowX = Dimensions.get('window');
    const ANIMATED = {
        OPEN_HEIGHT: windowX.height * finalOffSet,
        CLOSE_HEIGHT: windowX.height * initialOffset,
    };
    useEffect(() => {
        if (open === true) {
            animateMove(ANIMATED.OPEN_HEIGHT);
        }
        else {
            animateMove(ANIMATED.CLOSE_HEIGHT);
        }
    }, [open]);
    const STARTING_POSITION = ANIMATED.CLOSE_HEIGHT;
    const animatedPosition = new Animated.Value(STARTING_POSITION);
    const animateMove = (toValue) => {
        console.log('animateMove: ', toValue);
        if (toValue) {
            Animated.spring(animatedPosition, {
                toValue,
                useNativeDriver: true,
            }).start();
        }
    };
    const openModal = async () => {
        await setOpen(true);
    };
    const closeModal = async () => {
        if (scrollOffSetY === 0) {
            await setOpen(false);
        }
    };
    const isSwipeUp = (gestureState) => {
        return gestureState.dy <= -scrollValue;
    };
    const isSwipeDown = (gestureState) => {
        return gestureState.dy >= scrollValue;
    };
    const onMoveShouldSetPanResponder = (_, gestureState) => {
        return (isSwipeUp(gestureState) ||
            isSwipeDown(gestureState));
    };
    const onPanResponderMove = (_, gestureState) => {
        if (open === true &&
            isSwipeDown(gestureState)) {
            closeModal();
        }
        if (open === false && isSwipeUp(gestureState)) {
            openModal();
        }
    };
    const onPanResponderRelease = (_, gestureState) => {
        if (open === true &&
            isSwipeDown(gestureState)) {
            closeModal();
        }
        if (open === false && isSwipeUp(gestureState)) {
            openModal();
        }
    };
    const panGesture = PanResponder.create({
        onPanResponderMove,
        onPanResponderRelease,
        onMoveShouldSetPanResponder,
        onPanResponderTerminationRequest: (evt, gestureState) => true,
        onStartShouldSetPanResponderCapture: onMoveShouldSetPanResponder,
    });
    const headerContent = (React.createElement(React.Fragment, null,
        headerChildren,
        renderItem &&
            widgetHeaderItems &&
            widgetHeaderItems.map(renderItem)));
    const content = (React.createElement(React.Fragment, null,
        children,
        renderItem &&
            widgetItems &&
            widgetItems.map(renderItem)));
    const styles = StyleSheet.create({
        container: {
            width: '100%',
            borderTopLeftRadius: borderRadiusMapping[BorderRadiusTokens.BR3],
            borderTopRightRadius: borderRadiusMapping[BorderRadiusTokens.BR3],
            backgroundColor: colorMapping[ColorTokens.White],
            borderWidth: 1,
            borderColor: colorMapping[ColorTokens.Grey_Milk_1],
            shadowColor: colorMapping[ColorTokens.Grey_Milk_1],
            shadowOffset: {
                width: 0,
                height: 3,
            },
            shadowOpacity: 0.27,
            shadowRadius: 4.65,
            elevation: 6,
            paddingLeft: padding.left ? padding.left : 16,
            paddingRight: padding.right
                ? padding.right
                : 16,
            paddingTop: padding.top ? padding.top : 0,
            paddingBottom: padding.bottom
                ? padding.bottom
                : 0,
            paddingVertical: padding.vertical
                ? padding.vertical
                : 0,
            paddingHorizontal: padding.horizontal
                ? padding.horizontal
                : 16,
        },
        gestureArea: {
            width: '100%',
            height: 35,
            justifyContent: 'center',
            alignItems: 'center',
        },
        pullItem: {
            position: 'relative',
            bottom: 8,
            width: 48,
            height: 5,
            borderRadius: borderRadiusMapping[BorderRadiusTokens.BR3],
            backgroundColor: colorMapping[ColorTokens.Grey_Milk_1],
        },
        content: {
            flex: 1,
        },
        headerContent: {},
    });
    const handleScroll = async (e) => {
        console.log(e.nativeEvent.contentOffset);
        await setScrollOffSet(e.nativeEvent.contentOffset.y);
    };
    return (React.createElement(Animated.View, { style: [
            styles.container,
            { height: animatedPosition },
        ], ...panGesture.panHandlers },
        React.createElement(View, { style: styles.gestureArea },
            React.createElement(View, { style: styles.pullItem })),
        React.createElement(SafeAreaView, { style: styles.content },
            React.createElement(View, { style: styles.headerContent }, headerContent),
            React.createElement(ScrollView, { scrollEnabled: open, onScroll: handleScroll, showsVerticalScrollIndicator: false }, content))));
};
export default memo(BottomSheetBase);
export { BottomSheetBase };
